{
  "back": "Voltar",
  "form": "Formulário",
  "purposeTitle": "Qual é o motivo da sua visita?",
  "appointmentInfoTitle": "Informações do agendamento",
  "appointmentInfoHint": "Preencha este campo se você tiver um agendamento.",
  "checkInDetailsTitle": "Detalhes do check-in",
  "checkInDetailsHint": "Informações adicionais sobre sua visita.",
  "driverPhoneLabel": "Número de telefone do motorista",
  "activateWhatsAppTitle": "Ativar mensagens pelo WhatsApp",
  "activateWhatsAppBody": "Para conversar com o armazém, por favor responda \"OK\" quando enviarmos a primeira mensagem pelo WhatsApp.",
  "whatsappDelayBanner": "A primeira mensagem pelo WhatsApp pode levar até um minuto para chegar.",
  "notesLabel": "Observações",
  "notesPlaceholder": "Alguma instrução especial ou observação para a unidade?",
  "addNoteToWarehouse": "Adicionar nota para o armazém",
  "verifyAndCheckIn": "Verificar e fazer check-in",
  "completeCheckIn": "Concluir check-in",
  "visitGroupInbound": "Descarga",
  "visitGroupOutbound": "Carga",
  "visitGroupBoth": "Descarga e Carga",
  "visitUnloadTruck": "Descarregar meu caminhão",
  "visitDropTrailer": "Deixar meu reboque ou contêiner",
  "visitLoadTruck": "Carregar meu caminhão",
  "visitHookTrailer": "Engate de reboque ou contêiner",
  "visitUnloadLoad": "Descarregar e carregar meu caminhão",
  "visitDropHook": "Deixar e engatar reboque ou contêiner",
  "containerTrailer": "Reboque",
  "containerContainer": "Contêiner",
  "containerOversized": "Carga especial",
  "containerOther": "Outro",
  "defaultReferenceName": "Número do pedido",
  "identifierSuffix": "{reference} ou número de confirmação",
  "licenseOrDotRequired": "Por favor, preencha a placa do veículo ou o número DOT",
  "appointmentNotFound": "Não foi possível localizar seu agendamento",
  "referenceNotFound": "Nenhum agendamento correspondente encontrado. Os números de referência diferenciam maiúsculas de minúsculas.",
  "referenceCaseSensitiveHint": "O número de referência diferencia maiúsculas de minúsculas",
  "messaging": {
    "whatsappFailedTitle": "Não foi possível enviar mensagem pelo WhatsApp",
    "smsFailedTitle": "Não foi possível enviar mensagem SMS",
    "whatsappFailedBody": "Não conseguimos enviar uma mensagem para {displayPhone}. <br /><br /> Se você cancelou a inscrição anteriormente, envie START para <a href='{waUrl}' target='_blank' rel=\"noopener noreferrer\">{senderPhone}</a> para receber mensagens deste armazém.",
    "smsFailedBody": "Não conseguimos enviar uma mensagem para {displayPhone}. <br /><br /> Se você cancelou a inscrição anteriormente, envie START para <a href='{smsUrl}'>{senderPhone}</a> para receber mensagens SMS deste armazém.",
    "fallbackPhone": "o número de telefone fornecido"
  }
}
